// Config
import { mappedDeclineCodeConstants } from '@JohnLewisPartnership/checkout-psp-ui';
import errorCodeConstants from '@constants/errorCodeConstants';

const getStripeDeclineCodeErrorMessage = ({ code = errorCodeConstants.CLIENT_STRIPE_PAYMENT_ERROR, declineCode }) => {
  switch (declineCode) {
    case mappedDeclineCodeConstants.INVALID_PAYMENT_DETAILS:
      return {
        code,
        message: 'Payment failed',
        body: 'Check your details or try a different payment type',
      };

    case mappedDeclineCodeConstants.INSUFFICIENT_FUNDS:
      return {
        code,
        message: 'Payment failed: Insufficient funds',
        body: 'Try again with a different card or payment type',
      };

    case mappedDeclineCodeConstants.ACCOUNT_LIMIT_REACHED:
      return {
        code,
        message: 'Payment failed: Account limit reached',
        body: 'Try again with a different card or payment type',
      };

    case mappedDeclineCodeConstants.PROVIDER_DECLINED:
      return {
        code,
        message: 'Payment declined',
        body: 'Contact your card issuer or try a different payment type',
      };

    case mappedDeclineCodeConstants.AUTHENTICATION_FAILED:
      return {
        code,
        message: 'Authentication failed',
        body: 'Follow the instructions to continue or try again',
      };

    case mappedDeclineCodeConstants.RETRY_DIFFERENT_CARD:
      return {
        code,
        message: 'Payment failed',
        body: 'Try again with a different card or payment type',
      };

    case mappedDeclineCodeConstants.TECHNICAL_ERROR:
      return {
        code,
        message: 'Something went wrong',
        body: 'Please try again',
      };

    case mappedDeclineCodeConstants.PROVIDER_LOGIN_REQUIRED:
      return {
        code,
        message: 'Payment declined',
        body: 'Log into your payment provider or try a different payment type',
      };

    case mappedDeclineCodeConstants.PAYMENT_METHOD_EXPIRED:
      return {
        code,
        message: 'Payment failed',
        body: 'The payment method or card associated with your account has expired. Update your details and try again.',
      };

    case mappedDeclineCodeConstants.PROVIDER_TECHNICAL_ERROR:
      return {
        code,
        message: 'Something went wrong with the payment provider',
        body: 'Please try again',
      };

    case mappedDeclineCodeConstants.UNKNOWN:
      return {
        code,
        message: 'Something went wrong',
        body: 'Please try again, or use a different payment method',
      };

    default:
      return {
        code,
        message: "Sorry, we've been unable to process your payment",
        body: 'Please try again or try using another payment method.',
      };
  }
};

export default getStripeDeclineCodeErrorMessage;
